import { ActionCreatorWithPayload, createAction } from "@reduxjs/toolkit";

export const setIframeURL = createAction<string | undefined>(
    "iframe_url/set",
) as ActionCreatorWithPayload<string | undefined>;
